import { Component, ViewChild } from "@angular/core";
import { BaseListComponent } from "../../SharedModule/BaseListComponent/base-list.component";
import { Pagination } from "../../model/Helpers/Pagination";
import { SortInfo } from "../../model/Helpers/SortInfo";
import { Filter } from "../../model/Helpers/Filter";
import { MatSort } from "@angular/material/sort";
import { merge } from "rxjs/observable/merge";
import {TransportStatsService} from '../../services/transport-stats.service';
import {TransportStatsDataSource} from '../../model/DataSources/TransportStatsDataSource';

@Component({
    selector: "transport-stats",
    templateUrl: "./transportStats.component.html",
})
export class TransportStatsComponent extends BaseListComponent {
    displayedColumns: string[] = ["name", "total", "totalDay", "totalNight"];


    @ViewChild(MatSort) sort: MatSort;

    constructor(
        private transportStatsService: TransportStatsService,
    ) {
        super();

        const now = new Date();
        const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
        const monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0);

        this.defaultFilters = {
            from: monthStart,
            to: monthEnd,
            predefinedPeriod: "thisMonth",
        };
        this.filters = {
            from: monthStart,
            to: monthEnd,
            predefinedPeriod: "thisMonth",
        };

        this.dataSource = new TransportStatsDataSource(this.transportStatsService);
    }

    ngAfterViewInit() {
        this.prepareDataLoading();
        this.loadData();
    }


    prepareDataLoading() {
        merge(
            this.sort.sortChange,
            this.dataChangedEventSubject
        ).subscribe(() => {
            if (!this.dataSource) {
                return;
            }
            this.loadData();
            // this.applySort();
        });
    }

    loadData() {
        this.dataSource.loadPage(
            new Pagination(
                9999999,
                this.pageSize * this.initialPageIndex
            ),
            // new SortInfo(this.sort.active, this.sort.direction),
            null,
            this.getFilters(),
            {
                expand: 'transportStats,role'
            }
        );
    }

    // applySort() {
    //     const sorted = this.dataSource.getData().slice().sort((a, b) => {
    //         const active = this.sort.active;
    //         const direction = this.sort.direction === 'asc' ? 1 : -1;
    //         if (a[active] < b[active]) return -1 * direction;
    //         if (a[active] > b[active]) return 1 * direction;
    //         return 0;
    //     });
    //     this.dataSource._data = sorted;
    // }

    getFilters() {
        const filters: Filter[] = [];

        if (this.filters.from) {
            filters.push(new Filter("from", this.filters.from.toISOString()));
        }
        if (this.filters.to) {
            filters.push(new Filter("to", this.filters.to.toISOString()));
        }

        return filters;
    }

    setPredefinedPeriod(period: string): void {
        this.filters.predefinedPeriod = period;

        const now = new Date();

        switch (period) {
            case "lastMonth":
                const lastMonth = new Date(
                    now.getFullYear(),
                    now.getMonth() - 1,
                    1
                );
                const lastMonthEnd = new Date(
                    now.getFullYear(),
                    now.getMonth(),
                    0
                );
                this.filters.from = lastMonth;
                this.filters.to = lastMonthEnd;
                break;

            case "thisYear":
                const yearStart = new Date(now.getFullYear(), 0, 1);
                const yearEnd = new Date(now.getFullYear(), 11, 31);
                this.filters.from = yearStart;
                this.filters.to = yearEnd;
                break;
            case "thisMonth":
                const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
                const monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0);
                this.filters.from = monthStart;
                this.filters.to = monthEnd;
                break;
            case "thisWeek":
                const firstDayOfWeek = new Date(now);
                firstDayOfWeek.setDate(now.getDate() - now.getDay() + 1); // pondělí
                firstDayOfWeek.setHours(0, 0);
                const lastDayOfWeek = new Date(firstDayOfWeek);
                lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6); // Neděle
                lastDayOfWeek.setHours(23, 59);
                this.filters.from = firstDayOfWeek;
                this.filters.to = lastDayOfWeek;
                break;

            case "custom":
                // Keep current dates, just change the period
                break;
        }

        this.reloadPage();
    }

    onDateChange(): void {
        // When user manually changes dates, switch to custom period
        this.filters.predefinedPeriod = "custom";
        this.reloadPage();
    }

    resetFilters() {
        const now = new Date();
        const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
        const monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        this.filters.from = monthStart;
        this.filters.to = monthEnd;
        this.reloadPage();
    }
}



// WEBPACK FOOTER //
// /app/src/TransportModule/TransportStatsComponent/transportStats.component.ts